var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { SchemaItemType } from "@@/Schema";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { SelectMemberDialogState } from "../UIComponents/SelectMemberDialog";
export class MetadataDialogState {
    constructor() {
        this.editmode = false;
        this.show = false;
        this.name = "";
        this.derived = false;
        this.schemaitems = [];
        this.oitems = [];
        this.letrid = "";
        this.editschema = undefined;
        this.saving = false;
        this.dragging = false;
        this.dragzone = "";
        this.dragginitem = undefined;
        this.activeitemid = "";
        this.activeitem = undefined;
        this.choiceitems = [];
        this.vieweabletoeveryone = true;
        this.smstate = new SelectMemberDialogState();
        this.dateformats = [];
        this.activedatasheet = "";
        this.savingid = "";
        this.derviedschema = "";
        this.removedschema = new Map();
        this.showtypesmenu = false;
        this.dialog = new BaseDialogState();
        makeObservable(this);
        this.dialog.setHeaderLabel("Metadata");
        this.dialog.setCancelLabel("Close");
        this.dialog.setOkLabel("Add");
        this.dialog.onOk = () => {
            this.save();
        };
        APPEvent.addSubcriberForAddMetadata((sh) => {
            this.setShow(false);
            this.setSaving(false);
        });
        APPEvent.addSubscriberForUpdateSchema((sc) => {
            this.setSaving(false);
            if (!sc.ok) {
                APPEvent.publishApperror("Sorry, failed to update metadata");
            }
            else {
                this.setShow(false);
            }
        });
    }
    setShowTypesMenu(show) {
        this.showtypesmenu = show;
    }
    setDragZone(zid) {
        this.dragzone = zid;
    }
    setViewableToEveryone(viewable) {
        this.vieweabletoeveryone = viewable;
    }
    moveItemBetween(item, min, max) {
        let rannum = Math.random() * (max - min) + min;
        while (rannum === 0) {
            rannum = Math.random() * (max - min) + min;
        }
        item.orderindex = rannum;
    }
    setDervied(derived) {
        this.derived = derived;
    }
    setChoiceItems(items) {
        this.choiceitems.splice(0, this.choiceitems.length);
        this.choiceitems.push(...items);
    }
    setName(name) {
        this.name = name;
    }
    addChoiceItem(item) {
        this.choiceitems.push(item);
    }
    setDervicedSchema(dh) {
        this.derviedschema = dh;
    }
    removeChoiceItem(item) {
        const index = this.choiceitems.indexOf(item);
        if (index > -1) {
            this.choiceitems.splice(index, 1);
        }
    }
    setActiveItemid(id) {
        this.activeitemid = id;
    }
    setActiveItem(item) {
        this.activeitem = item;
    }
    setSaving(saving) {
        this.saving = saving;
    }
    addSchemaItem(item) {
        this.schemaitems.push(item);
    }
    getSchemaItems() {
        return this.schemaitems.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
    }
    removeSchemaItem(item) {
        const index = this.schemaitems.indexOf(item);
        if (index > -1) {
            this.schemaitems.splice(index, 1);
            if (this.oitems.indexOf(item) > -1) {
                this.removedschema.set(item.id, item);
            }
        }
    }
    save() {
        if (this.schemaitems.length === 0 && this.removedschema.size === 0) {
            return;
        }
        for (let i = 0; i < this.schemaitems.length; i++) {
            const element = this.schemaitems[i];
            if (element.type === SchemaItemType.Choice &&
                (element.items === undefined || (element.items !== undefined && element.items.length === 0))) {
                APPEvent.publishApperror("Minimum one value is needed for choice item " + element.name);
                return;
            }
        }
        this.setSaving(true);
        const req = {
            additems: this.schemaitems,
            deleteitems: Array.from(this.removedschema.values()),
            updateitems: [],
            letrid: this.letrid
        };
        console.log(req);
        Apphandler.sendMessage("addmetadata", req);
    }
    reset() {
        this.removedschema.clear();
        this.dervivedsch = undefined;
        this.setShow(false);
        this.setSaving(false);
        this.setActiveItemid("");
        this.setActiveItem(undefined);
        this.setName("");
        this.setViewableToEveryone(true);
        this.smstate.reset();
        this.dateformats.splice(0, this.dateformats.length);
        this.schemaitems.splice(0, this.schemaitems.length);
        this.setEditMode(false);
        this.editschema = undefined;
        this.setDervied(false);
    }
    setShow(show) {
        this.show = show;
        this.dialog.setOpen(show);
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (mode) {
            this.dialog.setOkLabel("Edit");
        }
        else {
            this.dialog.setOkLabel("Add");
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "derived", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MetadataDialogState.prototype, "schemaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "dragzone", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], MetadataDialogState.prototype, "activeitemid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "activeitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MetadataDialogState.prototype, "choiceitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "vieweabletoeveryone", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MetadataDialogState.prototype, "dateformats", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "derviedschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], MetadataDialogState.prototype, "removedschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MetadataDialogState.prototype, "showtypesmenu", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setShowTypesMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setDragZone", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setViewableToEveryone", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setDervied", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "addChoiceItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setDervicedSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "removeChoiceItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setActiveItemid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setActiveItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "addSchemaItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "removeSchemaItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MetadataDialogState.prototype, "setEditMode", null);
